// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/3e6f58af/" + chunkId + "." + __webpack_require__.h() + ".v3e6f58af.js";
};